import { apiPost, apiPut } from '../../fetch/apiService';

export function saveSlideshow(slideshowId, model, signal) {
	if (model.isNew) {
		return apiPost('slideshows', model, null, { signal });
	}
	return apiPut(`slideshows/${slideshowId}`, model, null, { signal });
}
